/**
 * Auth-related utils located here can be used both on client and server side.
 * Use `~/server/utils/auth/server.ts` for server-only auth utils.
 */

import z from 'zod';

/**
 * This schema currently only contains a subset of all available fields in the
 * access token. Other fields aren't used yet. You can extend it as needed.
 */
export const accessTokenClaimsSchema = z.object({
    sub: z.string(),
    profession: z.string().nullish(),
    groups: z.array(z.string()).nullish()
});

export type AccessTokenClaims = z.infer<typeof accessTokenClaimsSchema>;

const addressSchema = z
    .object({
        firstName: z.string().nullish(),
        lastName: z.string().nullish(),
        addition: z.string().nullish(),
        street_address: z.string().nullish(),
        postal_code: z.string().nullish(),
        locality: z.string().nullish(),
        country: z.string().nullish()
    })
    .nullish();

const addressExtraSchema = z
    .object({
        firstName: z.string().nullish(),
        lastName: z.string().nullish(),
        addition: z.string().nullish(),
        street: z.string().nullish(), // This is the only difference to addressSchema
        postal_code: z.string().nullish(),
        locality: z.string().nullish(),
        country: z.string().nullish()
    })
    .nullish();

// TODO: Addresses are currently not returned by Keycloak
export const idTokenClaimsSchema = z.object({
    address_delivery: addressExtraSchema,
    address_extra1: addressExtraSchema,
    address_extra2: addressExtraSchema,
    address_extra3: addressExtraSchema,
    address_private: addressSchema,
    address: addressSchema,
    email: z.email(),
    family_name: z.string().nullish(),
    fax: z.string().nullish(),
    given_name: z.string().nullish(),
    groups: z.array(z.string()).nullish(),
    institution: z.string().nullish(),
    medicenumber: z.string().nullish(),
    name: z.string().nullish(),
    nickname: z.string().nullish(),
    personalTitle: z.string().nullish(),
    phone_private: z.string().nullish(),
    phone: z.string().nullish(),
    preferred_username: z.string().nullish(),
    preferredCountry: z.string().nullish(),
    preferredLanguage: z.string().nullish(),
    profession: z.string().nullish(),
    speciality: z.string().nullish(),
    sub: z.string(),
    title: z.string().nullish()
});

export type IDTokenClaims = z.infer<typeof idTokenClaimsSchema>;
